import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IonButton, IonIcon } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline, ticketOutline } from 'ionicons/icons';
import { QRCodeCanvas } from 'qrcode.react';
import moment from 'moment';
import Loading from '../../../components/spinner';
import { withTranslation } from '../../../lib/translate';
import Layout from '../../../components/layout';
import { NormalText, SmallText, Spacer, StrongText } from '../../../components/common';
import NoData from '../../../components/noData';
import Basket from '../../../lib/basket';
import { forwardTo } from '../../../lib/utils';
import { getMyEventsCurrent, getMyEventsUpcoming, getVouchers } from '../../../store/actions';
import { normalizeEventTickets } from '../ticketUtils';
import { VoucherModal } from '../../voucher';
import './index.css';

class Ticket extends React.Component {
  state = {
    activeIndex: 0,
    selectedVoucher: null,
  };

  componentDidMount() {
    if (!this.getPurchasedTickets() && !this.getEvent()) {
      this.props.dispatch(getMyEventsCurrent(1));
      this.props.dispatch(getMyEventsUpcoming(1));
    }
    this.props.dispatch(getVouchers());
  }

  backHandler = () => forwardTo('/tickets');

  getEventId = () => this.props.location?.state?.eventId;

  getEventName = () => this.props.location?.state?.eventName;

  isUsed = () => !!this.props.location?.state?.isUsed;

  getEvent = () => {
    const eventId = this.getEventId();
    const eventName = this.getEventName();
    const events = [
      ...(this.props.myEventsCurrent || []),
      ...(this.props.myEventsUpcoming || []),
      ...(this.props.myEventsHistory || []),
    ];
    return events.find((event) =>
      eventId != null ? event.id === eventId : event.name === eventName,
    );
  };

  getPurchasedTickets = () => {
    const { eventPurchase } = this.props;
    if (!this.props.location?.state?.ticketsPurchased || !eventPurchase) {
      return null;
    }
    const eventId = this.getEventId();
    if (eventId != null && String(eventPurchase.event_id) !== String(eventId)) {
      return null;
    }
    const tickets = eventPurchase.tickets || [];
    return tickets.length > 0 ? normalizeEventTickets({ tickets }) : null;
  };

  getTickets = () => {
    const purchased = this.getPurchasedTickets();
    if (purchased) {
      return purchased;
    }
    const event = this.getEvent();
    return event ? normalizeEventTickets(event) : [];
  };

  moveTo = (index, total) => {
    if (index < 0 || index > total - 1) {
      return;
    }
    this.setState({ activeIndex: index });
  };

  renderSwitcherArrow = (icon, targetIndex, total, disabled) => (
    <div
      className={`ticket-switcher-arrow pointer${disabled ? ' disabled' : ''}`}
      onClick={() => this.moveTo(targetIndex, total)}
    >
      <IonIcon icon={icon} />
    </div>
  );


  renderSwitcher = (tickets) => {
    const { __ } = this.props;
    const { activeIndex } = this.state;
    const total = tickets.length;

    return (
      <div className="box-wrapper ticket-switcher">
        {this.renderSwitcherArrow(chevronBackOutline, activeIndex - 1, total, activeIndex === 0)}
        <div className="ticket-switcher-position">
          <StrongText className="block">
            {__('Ticket {index} of {total}', { index: activeIndex + 1, total })}
          </StrongText>
          {total <= 10 &&
            <div className="ticket-switcher-dots">
              {tickets.map((ticket, i) => (
                <div
                  className={`ticket-switcher-dot${i === activeIndex ? ' active' : ''}`}
                  key={ticket.uuid || `dot-${i}`}
                />
              ))}
            </div>
          }

        </div>
        {this.renderSwitcherArrow(
          chevronForwardOutline,
          activeIndex + 1,
          total,
          activeIndex === total - 1,
        )}
      </div>
    );
  };

  renderTicketHero = (ticket, eventName) => {
    const { __ } = this.props;
    const isUsed = this.isUsed();

    return (
      <div className="box-wrapper ticket-hero">
        <div >
          <StrongText className="block">{eventName}</StrongText>
          {ticket.startTime && (
            <SmallText className={`block ${isUsed ? 'disabled-color' : ''}`}>
              {moment(ticket.startTime).format('MMMM D YYYY')}
            </SmallText>
          )}
          {ticket.ticketCode && (
            <>
              <Spacer size={2} />
              <SmallText className={`block ${isUsed ? 'disabled-color' : ''}`}>{__('Ticket ID')}</SmallText>
              <StrongText className={`block ticket-hero-code ${isUsed ? 'disabled-color' : ''}`}>{ticket.ticketCode}</StrongText>
            </>
          )}
        </div>
        {isUsed ? <div className="ticket-hero-qr-used ticket-hero-qr">
          <SmallText>{__('ATTENDED')}</SmallText>
        </div> :
          <>
            {ticket.qrCode && (
              <div className="ticket-hero-qr">
                <QRCodeCanvas value={ticket.qrCode} size={90} />
              </div>
            )}
          </>
        }

      </div>
    );
  };

  renderDetailRow = (label, value, isUsed) => {
    if (!value) {
      return null;
    }
    return (
      <div className="ticket-detail-row">
        <NormalText className={isUsed ? 'disabled-color' : ''}>{label}</NormalText>
        <div className={`ticket-detail-value `}>{value}</div>
      </div>
    );
  };

  renderDetails = (ticket) => {
    const { __ } = this.props;
    const isUsed = this.isUsed();

    return (
      <div className="box-wrapper">
        {this.renderDetailRow(
          __('Ticket Type'),
          ticket.tierName && (
            <>
              <StrongText className={`${isUsed ? 'disabled-color' : ""} bold label-color `}>{ticket.tierName}</StrongText>
              <span className={`ticket-badge${isUsed ? ' used' : ''}`}>
                <SmallText>{isUsed ? __('ATTENDED') : __('VALID')}</SmallText>
              </span>
            </>
          ),
          isUsed,
        )}
        {this.renderDetailRow(
          __('Purchase Date'),
          ticket.purchasedAt && <StrongText >{moment(ticket.purchasedAt).format('L')}</StrongText>,
          isUsed,
        )}
        {this.renderDetailRow(
          __('Confirmation No.'),
          ticket.orderReference && <StrongText>{ticket.orderReference}</StrongText>,
          isUsed,
        )}
        {this.renderDetailRow(
          __('Checked in'),
          ticket.checkedInAt && (
            <StrongText>{moment(ticket.checkedInAt).format('LL · h:mm A')}</StrongText>
          ),
          isUsed,
        )}
        {this.renderDetailRow(
          __('Total Paid'),
          ticket.pricePaid != null && (
            <StrongText className=" label-color bold">
              {Basket.formatPrice(ticket.pricePaid / 100, true)}
            </StrongText>
          ),
          isUsed,
        )}
      </div>
    );
  };

  /* a bundled reward is only usable if the account actually holds a voucher for it - match on
     reward_id, then report whether that voucher is still unredeemed */
  getRewardVoucher = (reward) => {
    const rewardId = reward.reward_id != null ? reward.reward_id : reward.id;
    const matching = (this.props.vouchers || []).filter(
      (voucher) => voucher.reward?.id === rewardId,
    );
    if (matching.length === 0) {
      return { status: 'missing' };
    }
    const available = matching.find((voucher) => !voucher.is_redeemed);
    if (available) {
      return { status: 'available', voucher: available };
    }
    return { status: 'redeemed', voucher: matching[0] };
  };

  viewVoucher = (voucher) => this.setState({ selectedVoucher: voucher });

  renderIncluded = (ticket) => {
    const { __ } = this.props;
    const rewards = ticket.bundledRewards || [];
    const isUsed = this.isUsed()
    if (rewards.length === 0) {
      return null;
    }

    return (
      <>
        <Spacer size={2} />
        <div className={`box-wrapper`}>
          <div className={`ticket-detail-row ticket-included-header`}>
            <IonIcon className={`${isUsed ? 'disabled-color' : ''}  `} icon={ticketOutline} />
            <StrongText className={`${isUsed ? 'disabled-color' : ''}`}>{__('Included with your ticket')}</StrongText>
          </div>
          {rewards.map((reward, i) => {
            const { status, voucher } = this.getRewardVoucher(reward);
            const isAvailable = status === 'available';

            return (
              <div
                className={`ticket-detail-row${status === 'redeemed' ? ' ticket-included-inactive' : ''
                  }${voucher ? ' pointer' : ''}`}
                key={reward.id || `reward-${i}`}
                onClick={voucher ? () => this.viewVoucher(voucher) : null}
              >
                <div className={`ticket-included-data ${isUsed ? 'disabled-color' : ''}`}>
                  <StrongText className="block">
                    {reward.quantity > 1 ? `${reward.quantity} × ${reward.title}` : reward.title}
                  </StrongText>
                  {status === 'available' && voucher?.expiry_date && (
                    <SmallText className="block light-color">
                      {`${__('Expires')} ${moment(voucher.expiry_date, 'YYYY/MM/DD').format(
                        'MMMM D YYYY',
                      )}`}
                    </SmallText>
                  )}
                  {status === 'redeemed' && (
                    <SmallText className="block light-color">
                      {__('Already redeemed')}
                    </SmallText>
                  )}
                  {status === 'missing' && (
                    <SmallText className="block light-color">
                      {__('Not available on your account')}
                    </SmallText>
                  )}
                </div>
                {!isUsed && <>

                  {status === 'missing' ? (
                    <IonIcon className="ticket-included-chevron" icon={chevronForwardOutline} />
                  ) : (
                    <span className={`ticket-badge${isAvailable ? '' : ' used'}`}>
                      <SmallText>{isAvailable ? __('AVAILABLE') : __('REDEEMED')}</SmallText>
                    </span>
                  )}
                </>}
              </div>
            );
          })}
        </div>
      </>
    );
  };

  render() {
    const { selectedVoucher } = this.state;
    const tickets = this.getTickets();
    const activeIndex = Math.min(this.state.activeIndex, Math.max(tickets.length - 1, 0));
    const ticket = tickets[activeIndex];
    const eventName = this.getEventName() || ticket?.eventName;

    return (
      <Loading transparent>
        <Layout
          color="transparent"
          headerWithTitle
          title={eventName}
          backHandler={this.backHandler}
        >
          <div className="absolute-content ticket-content scrollable-y box-with-shadow">
            {tickets.length === 0 ? (
              <NoData label="No tickets found" />
            ) : (
              <>
                {tickets.length > 1 && (
                  <>
                    {this.renderSwitcher(tickets)}
                    <Spacer size={2} />
                  </>
                )}
                {this.renderTicketHero(ticket, eventName)}
                <Spacer size={2} />
                {this.renderDetails(ticket)}
                {this.renderIncluded(ticket)}

              </>
            )}
          </div>
        </Layout>
        <VoucherModal
          voucher={selectedVoucher}
          onDismiss={() => this.setState({ selectedVoucher: null })}
        />
      </Loading>
    );
  }
}

const stateToProps = (store) => {
  const { myEventsCurrent, myEventsUpcoming, myEventsHistory, eventPurchase } = store.orders;
  return {
    myEventsCurrent,
    myEventsUpcoming,
    myEventsHistory,
    eventPurchase,
    vouchers: store.profile.vouchers || [],
  };
};

export default connect(stateToProps)(withRouter(withTranslation(Ticket)));
